/// <amd-module name="Core/Medius.Core.Web/Scripts/components/taskHandling/shared/modals/rejectionManagementWizard/interfaces"/>
import { ExtensionsTypeLookup, ListItem, SortInfo } from "@medius/ui-controls";
import { ReasonCodeOperationDto } from "../shared/interfaces";

export enum RejectionType {
    Delete,
    Invalidate
}

export interface IReasonCode {
    id: number;
    reasonCode: string;
    description: string;
    systemReasonCode: string;
    operations: string[];
    types: string[];
    isSystemReasonCode: boolean;
    rejectionActionId? : number | null
}

export enum ReasonCodeType {
    Internal = "Internal",
    External = "External"
}

export interface IRejectionAction {
    id: number;
    code: string;
    name: string;
    description: string;
}

export interface ISupplierInvoiceRejectionDto extends ReasonCodeOperationDto {
    rejectedEntityType: string;
    rejectionType: RejectionType;
    hasExternalReasonCode: boolean;
    sendToSupplier: boolean;
    invoiceRejectionEmail?: IInvoiceRejectionEmailDto;
}

export interface IInvoiceRejectionEmailDto {
    emailTo: IRecipientAddress[];
    carbonCopy: IRecipientAddress[];
    sendCopy: boolean;
    messageSubject: boolean;
    content: string;
}

export interface IRecipientAddress {
    value: string;
}

export interface IInvoiceRejectionReasonItem {
    reasonCodeId: number;
    actionId?: number | null;
}

export interface IInvoiceReasonCodeData {
    invoiceReasonCodes: IReasonCode[];
    companyConfiguration: CompanyConfiguration;
    totalInvoiceReasonCodeCount: number;
    actions: ListItem[];
    isLoading: boolean;
    isError: boolean;
    paging: {
        currentPage: number;
        pageSize: number;
        changePage: (newPage: number) => void;
        changePageSize: (newPageSize: number) => void;
    };
    sorting: {
        sortInfo: SortInfo | null;
        changeSortInfo: (sortInfo: SortInfo | null) => void;
    };
    searching: {
        changeSearchTerm: (term: string) => void;
    };
}

export interface IEmailSettings { 
    currentUserEmail : string;
    currentUserLanguageCode : string;
    supplierLanguageCode : string;
}

export interface IEmailContent {
    subject: string;
    body: string;
}

export interface IEligibleForEmailCommunication {
    isEligible: boolean;
}

export interface CompanyConfiguration {
    isReasonRequiredUponRejection: boolean;
    supplierEmailForRejections: SupplierEmailForRejections;
}

export enum SupplierEmailForRejections
{
    suppliersContactPerson = "suppliersContactPerson",
    sendersEmailAddress = "sendersEmailAddress"
}

export interface DefaultSupplierEmail {
    emailSenderAddress?: string;
    supplierContactPersons: string[];
}

export interface RejectionReasonSelectionDto {
    reasonCode: string;
    reasonCodeDescription: string;
    rejectionActionCode?: string | null;
    rejectionActionDescription?: string | null;
}

export interface RejectionEmailContentRequestDto {
    invoiceRejectionReasons: RejectionReasonSelectionDto[],
    languageCode: string
}

// the same as for uploading attachment on the invoice
export const RejectionEmailSupportedAttachmentExtensions = [
    ExtensionsTypeLookup.csv,
    ExtensionsTypeLookup.doc,
    ExtensionsTypeLookup.docx,
    ExtensionsTypeLookup.gif,
    ExtensionsTypeLookup.jpegAll,
    ExtensionsTypeLookup.json,
    ExtensionsTypeLookup.msg,
    ExtensionsTypeLookup.pdf,
    ExtensionsTypeLookup.png,
    ExtensionsTypeLookup.ppt,
    ExtensionsTypeLookup.pptx,
    ExtensionsTypeLookup.ods,
    ExtensionsTypeLookup.txt,
    ExtensionsTypeLookup.xls,
    ExtensionsTypeLookup.xlsx,
    ExtensionsTypeLookup.xml,
    ExtensionsTypeLookup.zip,
    "application/octet-stream",
    "application/oxps",
    "application/postscript",
    "application/rtf",
    "application/vnd.etsi.asic-e+zip",
    "application/vnd.ms-excel",
    "application/vnd.ms-excel.sheet.binary.macroEnabled.12",
    "application/vnd.ms-excel.sheet.macroEnabled.12",
    "application/vnd.ms-powerpoint.presentation.macroEnabled.12",
    "application/vnd.ms-word.document.macroEnabled.12",
    "application/vnd.ms-xpsdocument",
    "application/vnd.oasis.opendocument.text",
    "application/vnd.openxmlformats-officedocument.presentationml.slideshow",
    "application/x-7z-compressed",
    "application/xslt+xml",
    "image/bmp",
    "image/svg+xml",
    "image/tiff",
    "image/vnd.dxf",
    "message/rfc822",
    "text/html"
];